module.exports = __webpack_public_path__ + "img/mobilescreens.25c71184.png";